
      import { createComponent } from '@lit/react'
      import { type EventName } from '@lit/react'
      import * as React from 'react'

      import Component from '../../components/navigation-menu/navigation-menu.component.js'
      import type { DdsNavigationItemClickEvent } from '../../events/events'
      export type { DdsNavigationItemClickEvent } from '../../events/events'

      const tagName = 'dap-ds-navigation-menu'

      /**
 * `dap-ds-navigation-menu`
 * @summary A horizontal navigation menu container that can contain multiple navigation items.
 * @element dap-ds-navigation-menu
 * @title - Navigation Menu
 *
 * @property {string} activeHref - The currently active href for highlighting active navigation items.
 * @property {'horizontal' | 'vertical'} orientation - The orientation of the navigation menu.
 *
 * @event {{ href: string, event: Event }} dds-navigation-item-click - Fired when a navigation item is clicked.
 *
 * @slot - The navigation menu list and items.
 *
 * @csspart base - The main navigation menu container.
 */
      const reactWrapper = createComponent({
        tagName,
        elementClass: Component,
        react: React,
        events: {
          onDdsNavigationItemClick: 'dds-navigation-item-click' as EventName<DdsNavigationItemClickEvent>
        },
        displayName: "DapDSNavigationMenu"
      })

      export default reactWrapper
    